<template>
    <div class="video-slider-section">
        <BaseSection data-width="bleed">
            <template v-if="title" #title>{{ title }}</template>
            <template #default>
                <div class="bleed">
                    <BaseSlider
                        :controls-enabled="true"
                        :items="videos"
                    >
                        <template v-slot:slide="{ item }">
                            <VideoCard
                                drag-to-scroll="ignore"
                                draggable="false"
                                has-bg="mobile"
                                :video="item"
                            />
                        </template>
                    </BaseSlider>
                </div>
            </template>
        </BaseSection>
    </div>
</template>

<script setup>

defineProps({
    title: {
        type: String,
        default: ''
    },
    videos: {
        type: Array,
        default: () => []
    }
});

</script>

<style lang="less">
.video-slider-section.section--no-margin {
    .section {
        margin: 0;
    }
}
</style>
